<template>
  <div class="flex w-full h-full overflow-hidden p-3">
    <div class="flex flex-col gap-6 w-full max-w-[30rem] mx-auto bg-[#2F2D45] rounded-2xl p-4">
      <div
        class="flex items-center justify-between w-full py-1 px-4 h-14 rounded-lg bg-[#1E1B2B] shrink-0"
      >
        <div>{{ t('checkout.total-amount') }}</div>
        <div class="flex items-center">{{ currency(amount) }}</div>
      </div>

      <div class="flex items-center justify-between">
        <div class="font-medium">{{ t('checkout.choose-tip') }}</div>
      </div>

      <div class="grid gap-4">
        <l-button-pos
          v-for="percentage in percentages"
          :key="percentage"
          class="bg-n-600"
          type="alternative"
          size="large"
          :disabled="disabled"
          @click="onPercentage(percentage)"
        >
          {{ percentage }}%
        </l-button-pos>
        <l-button-pos
          class="bg-n-600"
          type="alternative"
          size="large"
          :disabled="disabled"
          @click="$emit('selectCustom')"
        >
          {{ t('checkout.custom-amount') }}
        </l-button-pos>
        <l-button-pos
          class="bg-n-900"
          type="alternative"
          size="large"
          :disabled="disabled"
          @click="$emit('selectNoTip')"
        >
          {{ t('checkout.no-tip') }}
        </l-button-pos>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useMoney } from '@/composables/useMoney'

import LButtonPos from './LButton.vue'

type Props = {
  amount: number
  percentages: number[]
  disabled?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  selectPercentage: [number]
  selectCustom: []
  selectNoTip: []
}>()

const { currency } = useMoney()
const { t } = useI18n()

function onPercentage(value: number) {
  const tipAmount = Math.round((props.amount * value) / 100)
  emit('selectPercentage', tipAmount)
}
</script>
